import React from 'react';
import PropTypes from 'prop-types';
import css from 'profile/ProfileDropdown.scss';
import { daysOfTheWeekOptions } from 'utils/time';
import Select from 'common/StyledSelect';
import { find } from 'lodash';
import classnames from "classnames";
import { isEmptyString } from "utils/text";

const WeeklyDropdown = (props) => {
    return <Select id={props.id}
                   ariaLabel={props.ariaLabel}
                   placeholder={props.placeholder}
                   className={classnames(css['dropdown'], {[props.className]: !isEmptyString(props.className)})}
                   hasError={props.hasError}
                   isSearchable
                   isDisabled={props.isDisabled}
                   onChange={day => props.onChange(day.value)}
                   options={props.options}
                   value={find(props.options, ['value', props.value]) || null} />
};

WeeklyDropdown.daysOfTheWeekType = PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    })
);

WeeklyDropdown.defaultProps = {
    isDisabled: false,
    hasError: false,
    placeholder: '',
    options: daysOfTheWeekOptions
};

WeeklyDropdown.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    hasError: PropTypes.bool,
    options: WeeklyDropdown.daysOfTheWeekType,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired
};

export default WeeklyDropdown;
